import React from 'react';
import "./TableComp.css"

const TableComp = () => {
  const services = [
    { name: 'Haircut', price: '50' },
    { name: 'Beard Shaping', price: '50' },
    { name: 'Haircut and Hair Wash', price: '80' },
    { name: 'Hair Wash with Hair Massage and Blow-Dry', price: '50 ' },
    { name: 'Beard Coloring', price: '80  / with shaping 120 ' },
    { name: 'Professional Hairstyle', price: 'Top Model 15 / Package 300 ' },
    { name: 'Haircut Package', price: '100 ' },
    { name: 'Complete Package with Hair Wash', price: '120' },
    { name: 'VIP Services', price: '' }, 
    { name: 'Haircut', price: '100' },
    { name: 'Beard Shaping', price: '70 ' },
    { name: 'Haircut with Hair Wash', price: '200' },
  ];

  return (
    <div className='blur-10'>
    <div className='container-services'>
      <h2>SERVICE LIST</h2>
      <table>
        <thead>
          <tr>
            <th>Service</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {services.map((service, index) => (
            <tr key={index}>
              <td>{service.name}</td>
              <td>{service.price} &euro;</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default TableComp;
